import React, { useRef, useEffect, useState, memo } from 'react';
import NoSelectHtml, { NoSelectRegion } from './NoSelectHtml';
import CanvasHtml from './CanvasHtml';
// import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';

import classes from './Meaning.module.css'

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'

const parseJSON = (resp) => (resp.json ? resp.json() : resp);
const checkStatus = (resp) => {
    if (resp.status >= 200 && resp.status < 300) {
      return resp;
    }
  
    return parseJSON(resp).then(resp => {
      throw resp;
    });
};




function Meaning({
    pageContent={pageContent},
    basicDictionary = false,
    openDictionary = false,
    bookDictionary = false,
    meaningUnauthorized = false,
    translationUnauthorized = false,
    selectedTermTextForTitle = '',
    subtitleByLang = {},
    termNotSelected,
    meaning, 
    meaningHasSynonym,
    id, 
    language,
    onClick4 = f => f, 
    listOfCurrentTraductions, 
    meaningTranslation, 
    searchLanguage, 
    baseTermId, 
    isLoadingMeaningTranslation, 
    setIsLoadingMeaningTranslation = f => f, 
    mobile,
    setMobileMeaningStyle = f => f, 
    mobileMeaningStyle, 
    setShareId = f => f,
    skeletonWidth,
    setSkeletonWidth = f => f,
    timeToFetch,
    // spaceTaken,
    // setSpaceTaken = f => f
}) {



    function createMarkup(str) {
        return {__html: str};
    }

    const account = window.localStorage.getItem("account");
    const isBookAccount = account === "2" || account === 2;



    const [blurSize, setBlurSize] = useState({
        blurWidth: '',
        blurHeight: '',
        blurTop: ''

    })

    const [spaceTaken, setSpaceTaken] = useState(0)

    const [titleHeight, setTitleHeight] = useState(0)
    const [noTranslationSelected, setNoTranslationSelected] = useState(false)
    const [activeLang, setActiveLang] = useState(searchLanguage || 'de')

    useEffect(() => {
        setNoTranslationSelected(false)
        setActiveLang(searchLanguage || 'de')
    }, [id, searchLanguage])

    useEffect(() => {
        if (id && meaning?.locale != null) {
            const loc = (String(meaning.locale).toLowerCase?.() || String(meaning.locale)).slice(0, 2)
            setActiveLang(loc)
        }
    }, [id, meaning?.locale])

    // useEffect(() =>{
    //     if(id !== "0" && openDictionary && !termNotSelected) {
    //         setTimeout(() => {
    //             let dangerouslySetInnerHTML = document.getElementById('dangerouslySetInnerHTML').getElementsByTagName("a")
    //             Object.values(dangerouslySetInnerHTML).map(a => {
    //                 a.classList.add('tooltipTop')
    //                 a.href="javascript:void(0)"
    //             })
    //             Object.values(document.getElementsByClassName('tooltipTop')).map(a => a.appendChild(document.createElement("span")) )
    //             let tooltipContainer = document.getElementById('dangerouslySetInnerHTML').getElementsByTagName("span")
    //             Object.values(tooltipContainer).map(a=>a.classList.add('tooltipTopText'))
    //             Object.values(tooltipContainer).map(a=>a.innerHTML =  `<a class="link" style="color:#B66A00 !important;cursor: pointer;" href="/registration">Register</a> to use link`)
    //             console.log("Again")
    //         }, timeToFetch+ 5000);
    //     }
    // },[id, openDictionary, termNotSelected, timeToFetch])


    // const blockInternalLinks = () => {
    //     if(id !== "0" && openDictionary && meaning.free) {
    //         setTimeout(() => {
    //             let dangerouslySetInnerHTML = document.getElementById('dangerouslySetInnerHTML').getElementsByTagName("a")
    //             Object.values(dangerouslySetInnerHTML).map(a => {
    //                 a.classList.add('tooltipTop')
    //                 a.href="javascript:void(0)"
    //             })
    //             Object.values(document.getElementsByClassName('tooltipTop')).map(a => a.appendChild(document.createElement("span")) )
    //             let tooltipContainer = document.getElementById('dangerouslySetInnerHTML').getElementsByTagName("span")
    //             Object.values(tooltipContainer).map(a=>a.classList.add('tooltipTopText'))
    //             Object.values(tooltipContainer).map(a=>a.innerHTML =  `<a class="link" style="color:#B66A00 !important;cursor: pointer;" href="/registration">Register</a> to use link`)
    //         }, timeToFetch + 3000);
    //     }
    // }

    const ref = useRef(null)
    const testRef = useRef(null)

    useEffect(() => {
        

        if (  !isLoadingMeaningTranslation) {
            if(mobile && ref.current){
                setSpaceTaken(document.getElementById('termTitle').getBoundingClientRect().height + document.getElementById('termSubtitle').getBoundingClientRect().height + document.getElementById('termSynoyms').getBoundingClientRect().height + 35)
            } else if(!mobile && ref.current) {
                setSpaceTaken(document.getElementById('termTitle').getBoundingClientRect().height + document.getElementById('termSubtitle').getBoundingClientRect().height + document.getElementById('termSynoyms').getBoundingClientRect().height + 35)
            } else if (!mobile && (basicDictionary || openDictionary) && ref.current) {
                setSpaceTaken(document.getElementById('termTitle').getBoundingClientRect().height + document.getElementById('termSubtitle').getBoundingClientRect().height + document.getElementById('termSynoyms').getBoundingClientRect().height + 35 + 21)
            } else if(mobile && (basicDictionary || openDictionary) && ref.current) {
                setSpaceTaken(document.getElementById('termTitle').getBoundingClientRect().height + document.getElementById('termSubtitle').getBoundingClientRect().height + document.getElementById('termSynoyms').getBoundingClientRect().height + 35 + 42)
            } 
        }
        
    })
    
    
    

    return(
        termNotSelected
        ?
        <>
            <div style={{width:'100%'}}>
                <div style={{backgroundColor: bookDictionary ? '#F6F9E5' : '#E0F2F0'}} className={classes.meaningTermBoxNotSelected}>
                    {/* <div id='dangerouslySetInnerHTML' style={{display:'none'}}/> */}
                    <h1>
                        {/* {
                            language === "de"
                            ?
                            <>Wählen Sie einen Begriff</>
                            :
                            <>Choose a term</>
                        } */}
                        {pageContent.choose_term}
                    </h1>
                </div>
            </div>
        </>
        :
        <>
           
            <div ref={ref} style={{width:'100%'}}>
                <div style={{backgroundColor: bookDictionary ? '#F6F9E5' : '#E0F2F0'}} className={classes.meaningTermBox}>
                    <div className={classes.meaningTermCallToAction}>
                    {
                        mobile
                        ?
                        <>{
                            mobileMeaningStyle
                            ?
                            <button className={`${classes.meaningTermBackButton} none`} onClick={() =>  {setMobileMeaningStyle(false), setSpaceTaken(0)}}>
                                <i className='icon icon-arrow'></i>
                            </button>
                            : 
                            null
                        }</>
                        
                        : 
                        null
                    }
                    
                        <button 
                            className={`${classes.meaningTermShareButton} none`}
                            onClick={() => {setShareId(id, null)}}
                            disabled={openDictionary?true:false}
                        >
                            <i
                            style={{color: openDictionary ? 'grey': '#B66A00', cursor: openDictionary?'not-allowed':'pointer'}} className='tooltip icon icon-share'>
                            {
                                openDictionary
                                ?
                                <>
                                <span className="tooltiptext">
                                    <span dangerouslySetInnerHTML={createMarkup(pageContent.register_to_share)}/>
                                </span>
                                </>
                                :
                                <></>
                            }
                            </i>
                        </button>
                    </div>

                    <NoSelectRegion className={classes.meaningTermTitle}>
                        <h3 ref={testRef} id="termTitle">{meaningUnauthorized ? selectedTermTextForTitle : (meaning?.text || '')} </h3>  
                    </NoSelectRegion>

                    <div>
                        <div className={classes.changeLanguageButtons}>
                            {(() => {
                                const langs = [
                                    { code: 'de', label: mobile ? 'DE' : pageContent.lang_name_de },
                                    { code: 'fr', label: mobile ? 'FR' : pageContent.lang_name_fr },
                                    { code: 'it', label: mobile ? 'IT' : pageContent.lang_name_it },
                                    { code: 'en', label: mobile ? 'EN' : pageContent.lang_name_en },
                                ];
                                function getTranslationId(locale) {
                                    if (locale === 'de') return baseTermId != null ? baseTermId : id;
                                    if (locale === searchLanguage) return id;
                                    const list = listOfCurrentTraductions || [];
                                    for (let i = 0; i < list.length; i += 2) {
                                        if (list[i + 1] === locale) return list[i];
                                    }
                                    return null;
                                }
                                return langs.map(({ code, label }) => {
                                    const translationId = getTranslationId(code);
                                    const isActive = code === activeLang;
                                    const isCurrentLang = code === searchLanguage;
                                    const noTranslation = !translationId;
                                    const blockedByAccount = !isCurrentLang && openDictionary && meaning?.free === false && !isBookAccount;
                                    const unavailable = noTranslation || blockedByAccount;
                                        return (
                                            <button 
                                            key={code}
                                            onClick={meaningUnauthorized ? () => {} : () => {
                                                setActiveLang(code);
                                                if (unavailable) {
                                                    setNoTranslationSelected(true);
                                                    return;
                                                }
                                                setNoTranslationSelected(false);
                                                if (!(openDictionary && meaning?.free)) setIsLoadingMeaningTranslation(true);
                                                onClick4(translationId);
                                            }}
                                            style={{
                                                backgroundColor: isActive ? '#BD8F16' : '#FDFDFD',
                                                color: isActive ? '#FDFDFD' : '#BD8F16',
                                            }}
                                                className={`none ${classes.changeLanguageButton}`}
                                            >
                                            {label}
                                            </button>
                                    );
                                });
                            })()}
                        </div>
                        {
                            (openDictionary || basicDictionary) && meaning?.free
                            ?
                            <>
                            <span className={classes.openDictionaryLinks}>
                                {/* {
                                    language === 'de'
                                    ?
                                    <>*Um die Links nutzen zu können, müssen Sie über ein<Link to={`/aboutthebook`}> Buchkonto </Link> verfügen</>
                                    :
                                    <>*To use the links, please you must have a  <Link to={`/aboutthebook`}> book account</Link></>
                                } */}
                                <div dangerouslySetInnerHTML={createMarkup(pageContent.use_links_text)}/>
                            </span>
                            </>
                            :
                            <></>
                        }

                        <div style={{height: window.innerHeight < 900 && (!basicDictionary || !openDictionary) ? 'calc(85vh - 70px - 62px)':'calc(85vh - 70px - 132px)'}} className={classes.meaningTermContainer}>
                            {
                                isLoadingMeaningTranslation
                                ?
                                <>
                                <SkeletonTheme
                                    baseColor="#E1E2E1"
                                    highlightColor="#FDFDFD"
                                    borderRadius="10"
                                    duration={2}
                                >  
                                    <div className={classes.meaningTermSkeleton}>
                                        <div >
                                            <Skeleton />
                                        </div>
                                        <div>
                                            <Skeleton count={11} />
                                        </div>
                                    </div>   
                                </SkeletonTheme>
                                </>
                                :
                                <>
                                <NoSelectRegion className={classes.meaningTermSubtitleAndSynoyms}>
                                            {(() => {
                                        const baseLang = searchLanguage || 'de'
                                        const baseText = meaningUnauthorized
                                            ? selectedTermTextForTitle
                                            : (subtitleByLang[baseLang] || subtitleByLang.de || meaning?.text || '')
                                        const termLocale = meaning?.locale != null ? String(meaning.locale).toLowerCase().slice(0, 2) : ''
                                        const subtitleText =
                                            (termLocale && activeLang === termLocale && meaning?.text)
                                                ? meaning.text
                                                : (subtitleByLang[activeLang] || baseText)
                                                    return (
                                            <div id='termSubtitle' className={classes.meaningTermSubtitle}>{subtitleText}</div>
                                        );
                                            })()}
                                    {
                                        (activeLang === 'de' || meaningTranslation?.locale === activeLang)
                                        ?
                                        <>
                                            {
                                                openDictionary 
                                                ?
                                                <>
                                                <div id='termSynoyms' className={classes.meaningTermSynoyms}>   
                                                    {(() => {
                                                        if (!meaning || typeof meaning !== 'object' || Array.isArray(meaning)) {
                                                            return <></>;
                                                        }
                                                        const syns = meaning.synonyms;
                                                        const synonymCount = Array.isArray(syns)
                                                            ? syns.length
                                                            : (syns != null && typeof syns === 'object'
                                                                ? Object.keys(syns).length
                                                                : 0);
                                                        if (synonymCount === 0) {
                                                            return <></>;
                                                        }
                                                        if (synonymCount === 1) {
                                                            return (
                                                                <>{pageContent.Synonym}: {syns[0]?.text}</>
                                                            );
                                                        }
                                                        if (synonymCount === 2) {
                                                            return (
                                                                <>{pageContent.Synonyms}: {syns[0]?.text}, {syns[1]?.text}</>
                                                            );
                                                        }
                                                        if (synonymCount === 3) {
                                                            return (
                                                                <>{pageContent.Synonyms}: {syns[0]?.text}, {syns[1]?.text}, {syns[2]?.text}</>
                                                            );
                                                        }
                                                        if (synonymCount === 4) {
                                                            return (
                                                                <>{pageContent.Synonyms}: {syns[0]?.text}, {syns[1]?.text}, {syns[2]?.text}, {syns[3]?.text}</>
                                                            );
                                                        }
                                                        if (synonymCount === 5) {
                                                            return (
                                                                <>{pageContent.Synonyms}: {syns[0]?.text}, {syns[1]?.text}, {syns[2]?.text}, {syns[3]?.text}, {syns[4]?.text}</>
                                                            );
                                                        }
                                                        return <></>;
                                                    })()}
                                                </div>
                                                </>
                                                :
                                                <>

                                                    {
                                                        activeLang === 'de' || !meaningTranslation
                                                        ?
                                                        <>
                                                        <div id='termSynoyms' className={classes.meaningTermSynoyms}>   
                                                        {
                                                            {...{...{...{...meaning.synonyms}.data}[0]}.attributes}.text !== undefined && {...{...{...{...meaning.synonyms}.data}[1]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonym}: {{...{...{...{...meaning.synonyms}.data}[0]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            {...{...{...{...meaning.synonyms}.data}[1]}.attributes}.text !== undefined && {...{...{...{...meaning.synonyms}.data}[2]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonyms}: {{...{...{...{...meaning.synonyms}.data}[0]}.attributes}.text}, {{...{...{...{...meaning.synonyms}.data}[1]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            {...{...{...{...meaning.synonyms}.data}[2]}.attributes}.text !== undefined && {...{...{...{...meaning.synonyms}.data}[3]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonyms}: {{...{...{...{...meaning.synonyms}.data}[0]}.attributes}.text}, {{...{...{...{...meaning.synonyms}.data}[1]}.attributes}.text}, {{...{...{...{...meaning.synonyms}.data}[2]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            {...{...{...{...meaning.synonyms}.data}[3]}.attributes}.text !== undefined && {...{...{...{...meaning.synonyms}.data}[4]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonyms}: {{...{...{...{...meaning.synonyms}.data}[0]}.attributes}.text}, {{...{...{...{...meaning.synonyms}.data}[1]}.attributes}.text}, {{...{...{...{...meaning.synonyms}.data}[2]}.attributes}.text}, {{...{...{...{...meaning.synonyms}.data}[3]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                            
                                                        </div>
                                                        </>
                                                        :
                                                        <>
                                                         <div id='termSynoyms' className={classes.meaningTermSynoyms}>   
                                                        {
                                                            {...{...{...{...meaningTranslation.synonyms}.data}[0]}.attributes}.text !== undefined && {...{...{...{...meaningTranslation.synonyms}.data}[1]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonym}: {{...{...{...{...meaningTranslation.synonyms}.data}[0]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            {...{...{...{...meaningTranslation.synonyms}.data}[1]}.attributes}.text !== undefined && {...{...{...{...meaningTranslation.synonyms}.data}[2]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonyms}: {{...{...{...{...meaningTranslation.synonyms}.data}[0]}.attributes}.text}, {{...{...{...{...meaningTranslation.synonyms}.data}[1]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            {...{...{...{...meaningTranslation.synonyms}.data}[2]}.attributes}.text !== undefined && {...{...{...{...meaningTranslation.synonyms}.data}[3]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonyms}: {{...{...{...{...meaningTranslation.synonyms}.data}[0]}.attributes}.text}, {{...{...{...{...meaningTranslation.synonyms}.data}[1]}.attributes}.text}, {{...{...{...{...meaningTranslation.synonyms}.data}[2]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                        {
                                                            {...{...{...{...meaningTranslation.synonyms}.data}[3]}.attributes}.text !== undefined && {...{...{...{...meaningTranslation.synonyms}.data}[4]}.attributes}.text === undefined
                                                            ?
                                                            <>{pageContent.Synonyms}: {{...{...{...{...meaningTranslation.synonyms}.data}[0]}.attributes}.text}, {{...{...{...{...meaningTranslation.synonyms}.data}[1]}.attributes}.text}, {{...{...{...{...meaningTranslation.synonyms}.data}[2]}.attributes}.text}, {{...{...{...{...meaningTranslation.synonyms}.data}[3]}.attributes}.text}</>
                                                            :
                                                            <></>
                                                        }
                                                            
                                                        </div>
                                                        </>
                                                    }
                                                   
                                                </>
                                            }
                                            
                                          
                                        </>
                                        :
                                        <>
                                            <div id='termSynoyms' className={classes.meaningTermSynoyms}>   
                                                {
                                                    meaningTranslation?.synonyms?.data?.[0] !== undefined && meaningTranslation?.synonyms?.data?.[1] === undefined
                                                    ?
                                                    <>{pageContent.Synonym}: {meaningTranslation?.synonyms?.data?.[0]?.attributes?.text}</>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    meaningTranslation?.synonyms?.data?.[1] !== undefined && meaningTranslation?.synonyms?.data?.[2] === undefined
                                                    ?
                                                    <>{pageContent.Synonyms}: {meaningTranslation?.synonyms?.data?.[0]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[1]?.attributes?.text}</>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    meaningTranslation?.synonyms?.data?.[2] !== undefined && meaningTranslation?.synonyms?.data?.[3] === undefined
                                                    ?
                                                    <>{pageContent.Synonyms}: {meaningTranslation?.synonyms?.data?.[0]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[1]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[2]?.attributes?.text}</>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    meaningTranslation?.synonyms?.data?.[3] !== undefined && meaningTranslation?.synonyms?.data?.[4] === undefined
                                                    ?
                                                    <>{pageContent.Synonyms}: {meaningTranslation?.synonyms?.data?.[0]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[1]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[2]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[3]?.attributes?.text}</>
                                                    :
                                                    <></>
                                                }
                                                {
                                                    meaningTranslation?.synonyms?.data?.[4] !== undefined && meaningTranslation?.synonyms?.data?.[5] === undefined
                                                    ?
                                                    <>{pageContent.Synonyms}: {meaningTranslation?.synonyms?.data?.[0]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[1]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[2]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[3]?.attributes?.text}, {meaningTranslation?.synonyms?.data?.[4]?.attributes?.text}</>
                                                    :
                                                    <></>
                                                }
                                            </div>
                                        </>
                                    }
                                
                                </NoSelectRegion>
                                <div id={ openDictionary || basicDictionary ? 'meaningTextOpen' :'meaningText'} className={classes.meaningTermText} style={{height: bookDictionary?`calc(100vh - 180px - ${spaceTaken}px - 55px)`:`calc(100vh - 180px - ${spaceTaken}px - 95px)`}}>
                                    {
                                        openDictionary || basicDictionary
                                        ?
                                        <>
                                        {
                                            meaningUnauthorized
                                            ?
                                            <div className={classes.willBeAvailableSoonContainer}>
                                                <div className={classes.willBeAvailableSoon}>
                                                    <i className='icon-upgrade'></i>
                                                    <span>{pageContent.get_book_account}</span>
                                                    <Link
                                                            to={`/abouttheapp`}
                                                            className={'btn ochre size-auto'}
                                                            style={{color: 'white', textDecoration: 'none'}}
                                                        >
                                                            {pageContent.get_book_account_button}
                                                    </Link>
                                                </div>
                                            </div>
                                            :
                                            noTranslationSelected
                                            ?
                                            <div style={{backgroundColor: bookDictionary ? '#E0F2F0' : '#F6F9E5'}} className={classes.willBeAvailableSoonContainer}>
                                                <div className={classes.willBeAvailableSoon}>
                                                    <i className='icon icon-lock'></i>
                                                    <span>{pageContent.available_soon}</span>
                                                </div>
                                            </div>
                                            :
                                            translationUnauthorized
                                            ?
                                            <div className={classes.willBeAvailableSoonContainer}>
                                                <div className={classes.willBeAvailableSoon}>
                                                    <i className='icon-upgrade'></i>
                                                    <span>{pageContent.get_book_account}</span>
                                                    <Link
                                                            to={`/abouttheapp`}
                                                            className={'btn ochre size-auto'}
                                                            style={{color: 'white', textDecoration: 'none'}}
                                                        >
                                                            {pageContent.get_book_account_button}
                                                    </Link>
                                                </div>
                                            </div>
                                            :
                                            (meaning?.free || isBookAccount) && (meaningTranslation===false || meaningTranslation?.locale === "de")
                                            ?
                                            <>
                                                <CanvasHtml id='dangerouslySetInnerHTML' className={openDictionary || basicDictionary?classes.openDictionaryMeaning:''} html={meaning?.definition ?? ''} disableLinks={openDictionary && !isBookAccount} />
                                            </>
                                            :
                                            (meaning?.free || isBookAccount) && meaningTranslation && meaningTranslation?.locale !== "de" && meaningTranslation?.definition
                                            ?
                                            <>
                                                <CanvasHtml id='dangerouslySetInnerHTML' className={openDictionary || basicDictionary?classes.openDictionaryMeaning:''} html={meaningTranslation.definition} disableLinks={openDictionary && !isBookAccount} />
                                            </>
                                            :
                                            (!meaning?.free && !isBookAccount) || meaningUnauthorized
                                            ?
                                            <div className={classes.willBeAvailableSoonContainer}>
                                                <div className={classes.willBeAvailableSoon}>
                                                    <i className='icon-upgrade'></i>
                                                    <span>{pageContent.get_book_account}</span>
                                                    <Link
                                                            to={`/abouttheapp`}
                                                            className={'btn ochre size-auto'}
                                                            style={{color: 'white', textDecoration: 'none'}}
                                                        >
                                                            {pageContent.get_book_account_button}
                                                    </Link>
                                                </div>
                                            </div>
                                            :
                                            <div style={{backgroundColor: bookDictionary ? '#E0F2F0' : '#F6F9E5'}} className={classes.willBeAvailableSoonContainer}>
                                                <div className={classes.willBeAvailableSoon}>
                                                    <i className='icon icon-lock'></i>
                                                    <span>{pageContent.available_soon}</span>
                                                </div>
                                            </div>
                                        }
                                        </>
                                        :
                                        <>
                                            {(() => {
                                                if (noTranslationSelected) {
                                                    return (
                                                        <>
                                                        <div style={{backgroundColor:bookDictionary ? '#E0F2F0':'#F6F9E5'}} className={classes.willBeAvailableSoonContainer}>
                                                            <div className={classes.willBeAvailableSoon}>
                                                                <i className='icon icon-lock'></i>
                                                                <span>{pageContent.available_soon}</span>
                                                            </div>
                                                        </div>
                                                        </>
                                                    )
                                                } else if (((meaning?.definition === "" || meaning?.definition === null || meaning?.definition === undefined) && !meaningTranslation) || ( meaningTranslation?.definition === "" || meaningTranslation?.definition === null)) {
                                                    return (
                                                        <>
                                                        <div style={{backgroundColor:bookDictionary ? '#E0F2F0':'#F6F9E5'}} className={classes.willBeAvailableSoonContainer}>
                                                            <div className={classes.willBeAvailableSoon}>
                                                                <i className='icon icon-lock'></i>
                                                                <span>{pageContent.available_soon}</span>
                                                            </div>
                                                        </div>
                                                        </>
                                                    )
                                                } else if (meaning?.definition !== "" && meaning?.definition != null && !meaningTranslation) {
                                                    return (
                                                        <>
                                                        <CanvasHtml id='dangerouslySetInnerHTML' className={openDictionary || basicDictionary?classes.openDictionaryMeaning:''} html={meaning.definition} disableLinks={openDictionary && !isBookAccount} />
                                                        </>
                                                    )
                                                } else if (meaningTranslation.definition !== ""){
                                                    return (
                                                        <>
                                                        <CanvasHtml id='dangerouslySetInnerHTML' className={openDictionary || basicDictionary?classes.openDictionaryMeaning:''} html={meaningTranslation.definition} disableLinks={openDictionary && !isBookAccount} />
                                                        </>
                                                    )
                                                } 
                                            })()}
                                        </>
                                    }
                                    
                                    
                                   

                                   
                                </div>
                                </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default memo(Meaning);
